import type { FC } from 'react';
import { lazy } from 'react';
import { type SuperBundleServiceRequest } from 'src/apis/super-bundle-service/use-super-bundle-service-root';
import type { Successful } from 'src/hooks/use-axios';

const OfferCreateForm = lazy(() => import('./offer-create-form'));

export const SupedBundleOfferCreate: FC<{
  superBundleServiceRoot: Successful<SuperBundleServiceRequest>;
}> = ({ superBundleServiceRoot }) => {
  return <OfferCreateForm superBundleServiceRoot={superBundleServiceRoot} />;
};
